<template>
  <div class="jobs">
    <div class="jobs_banner">
      <img src="../../assets/img/jobs_banner.png" alt="" class="jobs_banner">
      <div class="jobs_btn" @click="goBuy">免费试用</div>
    </div>
    <div class="jobs_info">
      <div class="jobs_title">流程化高效管理招聘</div>
      <div class="jobs_text mTop30">一站式招聘管理，线上对后选人高效添加、面试、入职，海量数据直观展现提升HR效率</div>
      <div class="flex align-item-center justify-content-between mTop80">
        <div class="info_item">
          <img src="../../assets/img/jobs_info1.png" alt="" class="info_img">
        </div>
        <div class="info_icon">
          <img src="../../assets/img/jobs_info_icon.png" alt="" class="info_img">
        </div>
        <div class="info_item">
          <img src="../../assets/img/jobs_info2.png" alt="" class="info_img">
        </div>
        <div class="info_icon">
          <img src="../../assets/img/jobs_info_icon.png" alt="" class="info_img">
        </div>
        <div class="info_item">
          <img src="../../assets/img/jobs_info3.png" alt="" class="info_img">
        </div>
        <div class="info_icon">
          <img src="../../assets/img/jobs_info_icon.png" alt="" class="info_img">
        </div>
        <div class="info_item">
          <img src="../../assets/img/jobs_info4.png" alt="" class="info_img">
        </div>
        <div class="info_icon">
          <img src="../../assets/img/jobs_info_icon.png" alt="" class="info_img">
        </div>
        <div class="info_item">
          <img src="../../assets/img/jobs_info5.png" alt="" class="info_img">
        </div>
        <div class="info_icon">
          <img src="../../assets/img/jobs_info_icon.png" alt="" class="info_img">
        </div>
        <div class="info_item">
          <img src="../../assets/img/jobs_info6.png" alt="" class="info_img">
        </div>
      </div>
      <div class="flex align-item-center justify-content-between mTop30">
        <div class="info_item">添加候选人</div>
        <div class="info_item">初试</div>
        <div class="info_item">复试</div>
        <div class="info_item">面试通过</div>
        <div class="info_item">Offer</div>
        <div class="info_item">入职</div>
      </div>
    </div>
    <div class="jobs_part2">
      <div class="jobs_title">功能优势</div>
      <div class="jobs_text mTop30">智能化招聘管理技术支持，便捷式操作流程提高效率</div>
      <div class="flex align-item-center justify-content-between part2_flex">
        <div class="part2_img">
          <img src="../../assets/img/jobs_img2.png" alt="">
        </div>
        <div class="part2_content">
          <div class="part2_item">
            <div class="part2_title">简历解析</div>
            <div class="part2_text mTop10">批量导入候选人，一键解析简历信息</div>
          </div>
          <div class="part2_item mTop10">
            <div class="part2_title">线上填表</div>
            <div class="part2_text mTop10">在线填写应聘登记表，不受时间、地点限制</div>
          </div>
          <div class="part2_item mTop10">
            <div class="part2_title">Offer快速归档</div>
            <div class="part2_text mTop10">自动生成招聘数据表，管理便捷</div>
          </div>
          <div class="part2_item mTop10">
            <div class="part2_title">DING消息提醒面试官</div>
            <div class="part2_text mTop10">“钉”一下，消息及时通知</div>
          </div>
        </div>
      </div>
    </div>
    <div class="jobs_part3">
      <div class="part3_box flex align-item-center">
        <div class="part3_text">
          <div class="jobs_title">多平台操作</div>
          <div class="jobs_text mTop30">移动端和PC端信息协同，随时随地高效协作，全方位进行招聘管理</div>
        </div>
        <div class="part3_img">
          <img src="../../assets/img/jobs_img3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "2-2");
  },
  computed: {},
  methods: {
    goBuy(){
      this.$router.push({ name: 'download' });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/jobs.vue